module.exports = __webpack_public_path__ + "media/src/assets/images/circle-o-5fb8d8f65468ac92c9068b902aec40a1.svg";